import { classExists } from "../helper/class-exists";
import { clickButton } from "../helper/click-button";
import { slideToggle } from "../helper/slide-toggle";

const detectScrollbarX = (elem) => {
  return elem.scrollWidth > elem.clientWidth;
};

const tableEightScroll = (button, tableElem, scrollingPower) => {
  if (button.classList.contains("next")) {
    tableElem.scrollBy({
      top: 0,
      left: scrollingPower,
      behavior: "smooth",
    });
  } else {
    tableElem.scrollBy({
      top: 0,
      left: -1 * scrollingPower,
      behavior: "smooth",
    });
  }
};

const tableTriggerCollapse = (button, i, elem) => {
  elem[i].click();
};

const tableCollapse = (button, i, elem) => {
  const currText = button.textContent;
  const detail = elem[i].querySelector(".info");

  if (currText === button.dataset.text && detail.style.display !== "block") {
    button.innerHTML = button.dataset.altText;
    slideToggle(detail, 500);
  } else {
    button.innerHTML = button.dataset.text;
    slideToggle(detail, 500);
  }
};

const tableEight = () => {
  const elems = document.querySelectorAll(".js-table-eight");
  classExists(elems);

  for (let i = 0; i < elems.length; i++) {
    const tableElem = elems[i].querySelector(".table-eight-overflow");
    let tableFlagContainer = tableElem.querySelectorAll(".js-trader-flags");
    // let tableFlagButton = tableElem.querySelectorAll(".js-trader-flags button");

    if (detectScrollbarX(tableElem)) {
      elems[i].querySelector(".table-eight-title")?.classList.add("scroll-exists");
    } else {
      elems[i].querySelector(".table-eight-title")?.classList.remove("scroll-exists");
    }

    if (elems[i].classList.contains("has-logo")) {
      const details = elems[i].querySelectorAll(".details");
      tableEightResize(details, tableElem);
    }

    // if (tableFlagButton[i]) {
    //   tableFlagButton[i].addEventListener("click", function (event) {
        //   tableFlagContainer[i].classList.toggle("is-open");
    //   });
    // }
  }
  
    let tableFlagButtons = document.querySelectorAll('.js-trader-flags button');
    if (tableFlagButtons.length > 0) {
        tableFlagButtons.forEach((tableFlagButton) => {
            tableFlagButton.addEventListener('click', (event) => {
                event.currentTarget.parentNode.classList.toggle('is-open');
            });
        });
    }
};

const tableEightScrollbar = () => {
  const elems = document.querySelectorAll(".js-table-eight");
  classExists(elems);

  for (let i = 0; i < elems.length; i++) {
    const tableElem = elems[i].querySelector(".table-eight-overflow");
    const buttonsElem = elems[i].querySelector(".table-eight-container");
    const buttonContainer = buttonsElem.querySelector(".scrollbar-buttons");
    const buttons = buttonContainer.querySelectorAll("button");
    const scrollingPower = buttonContainer.dataset.scrollPower;

    clickButton(buttons, (button) =>
      tableEightScroll(button, tableElem, scrollingPower)
    );
  }
};

const tableEightButtons = () => {
  const elems = document.querySelectorAll(".js-table-eight");
  classExists(elems);

  for (let i = 0; i < elems.length; i++) {
    if (elems[i].classList.contains("has-logo")) {
      const collapseButtons = elems[i].querySelectorAll(".button-collapse");
      const details = elems[i].querySelectorAll(".details");
      const detailButtons = elems[i].querySelectorAll(".button-hide-details");

      clickButton(collapseButtons, (button, i) =>
        tableCollapse(button, i, details)
      );

      clickButton(detailButtons, (button, i) =>
        tableTriggerCollapse(button, i, collapseButtons)
      );

      /* just hide the button if the collapse button to reveal the desc is empty */
      details.forEach((d, k) => {
        if (!d.querySelector('.info').childNodes.length) {
            collapseButtons[k].classList.add('hidden');
        }
      });  
    }
  }
};

const tableEightResize = (elem, tableElem) => {
  const infoWidth = tableElem.offsetWidth - 32;

  let columnAvailable = Math.trunc(tableElem.offsetWidth / 138);
  const tableSpans = tableElem.dataset.defaultSpan;

  const windowMedia = window.matchMedia("(max-width: 430px)");
  if (windowMedia.matches) {
    columnAvailable = columnAvailable + 1;
  }

  for (let i = 0; i < elem.length; i++) {
    const infoElem = elem[i].querySelector(".info");
    const addTd = document.createElement("td");
    addTd.classList.add("added-td");
    addTd.colSpan = tableSpans - columnAvailable;

    if (detectScrollbarX(tableElem)) {
      infoElem.style.maxWidth = infoWidth + "px";
      infoElem.classList.add("margin-removed");
      elem[i].querySelector("td").colSpan = columnAvailable;

      if (elem[i].querySelector(".added-td")) {
        elem[i].querySelector(".added-td").colSpan =
          tableSpans - columnAvailable;
      }

      if (!elem[i].querySelector(".added-td")) {
        elem[i].appendChild(addTd);
      }
    } else {
      infoElem.style.removeProperty("max-width");
      infoElem.classList.remove("margin-removed");

      elem[i].querySelector("td").colSpan = tableSpans;
      if (elem[i].querySelector(".added-td")) {
        elem[i].querySelector(".added-td").remove();
      }
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  tableEight();
  tableEightButtons();
  tableEightScrollbar();
});

window.addEventListener(
  "resize",
  function (event) {
    tableEight();
  },
  true
);
